/// <amd-module name="Wit/WorkItemFormMarkdown/FileUploadUtils" />
export const validFileTypeList = ["jpg", "jpeg", "png", "bmp", "gif"];
